/**
 * World Courier portal "Item Name" combobox options (label text from WC UI).
 * Portal HTML did not expose stable option ids in inspect; `value` matches `label`
 * until automation captures WC option keys.
 */

import type { WcSelectOption } from './worldCourierPackageFormOptions';

const WORLD_COURIER_ITEM_NAME_LABELS = [
  'AIR SAMPLES',
  'AIRCRAFT PART',
  'ALCOHOL',
  'ANCILLARIES',
  'ANIMAL ANTIBODY',
  'ANIMAL ANTIBODY UN3373',
  'ANIMAL BLOOD',
  'ANIMAL BLOOD UN3373',
  'ANIMAL CELLS',
  'ANIMAL CELLS UN3373',
  'ANIMAL DNA',
  'ANIMAL EMBRYOS',
  'ANIMAL EMBRYOS UN3373',
  'ANIMAL FAECES',
  'ANIMAL FAECES UN3373',
  'ANIMAL ORGANS',
  'ANIMAL ORGANS UN3373',
  'ANIMAL PLASMA',
  'ANIMAL PLASMA UN3373',
  'ANIMAL RNA',
  'ANIMAL SERUM',
  'ANIMAL SERUM UN3373',
  'ANIMAL SPERM',
  'ANIMAL SPERM UN3373',
  'ANIMAL TISSUE',
  'ANIMAL TISSUE UN3373',
  'ANIMAL URINE',
  'ANIMAL URINE UN3373',
  'ANTIBODY, OTHER',
  'API',
  'AUTOMOTIVE PART, NEW',
  'AUTOMOTIVE PART, USED',
  'BIOLOGICAL OTHER (NON HUMAN/ANIMAL MEDIUM)',
  'BROCHURES',
  'CGT CELL BANK',
  'CGT OTHER',
  'CGT STARTING MATERIAL',
  'CGT THERAPY',
  'CHEMICAL/SYNTHETIC COMPOUND',
  'CHEMICALS',
  'CHEMICALS NON BIO',
  'CLINICAL KITS: ANCILLARIES NO DRUGS',
  'CLINICAL KITS: CONTAINING DRUGS',
  'CLINICAL TRIAL MEDICINES',
  'CLOTHING',
  'COMPUTER',
  'COMPUTER PARTS',
  'CORAL SAMPLES',
  'CULTURES',
  'CULTURES/ISOLATES UN2814',
  'DAIRY PRODUCT',
  'DATA STORAGE AUDIO',
  'DATA STORAGE DEVICE',
  'DATA STORAGE VISUAL',
  'DEEP SEA SEDIMENT SAMPLES',
  'DIAGNOSTIC KITS',
  'DIAGNOSTIC MATERIAL',
  'DOCUMENTS',
  'DRAWINGS',
  'ELEC. DEVICES',
  'EMPTY PACKAGING',
  'ENZYME',
  'FILM, MOVIE',
  'FILM, ROLL',
  'FOOD SAMPLES',
  'FRUIT PRODUCT',
  'GRAIN PRODUCT',
  'HUMAN ANTIBODY',
  'HUMAN ANTIBODY UN3373',
  'HUMAN BLOOD',
  'HUMAN BLOOD UN3373',
  'HUMAN BONE BIOPSY',
  'HUMAN BONE BIOPSY UN3373',
  'HUMAN BONE MARROW',
  'HUMAN BONE MARROW UN3373',
  'HUMAN CELLS',
  'HUMAN CELLS UN3373',
  'HUMAN CORD BLOOD',
  'HUMAN CORD BLOOD UN3373',
  'HUMAN DNA',
  'HUMAN ORGANS',
  'HUMAN ORGANS UN3373',
  'HUMAN PLASMA',
  'HUMAN PLASMA UN3373',
  'HUMAN RNA',
  'HUMAN SERUM',
  'HUMAN SERUM UN3373',
  'HUMAN SPERM',
  'HUMAN SPUTUM',
  'HUMAN STOOL',
  'HUMAN TISSUE',
  'HUMAN TUMOR',
  'HUMAN TUMOR UN3373',
  'HUMAN URINE',
  'LAB EQUIPMENT',
  'LIVE ANIMALS',
  'LIVE FISH',
  'LIVE MICE',
  'LIVE RATS',
  'MACHINE PART',
  'MEAT PRODUCT',
  'MEDICAL DEVICES',
  'MEDICAL EQUIPMT',
  'MEDICAL WASTE',
  'MEDICINE (PERSONAL USE)',
  'MICRO-ORGANISMS',
  'OCEAN CORE SAMPLES',
  'OTHER ANCILLARIES',
  'OTHER BIO ANIMAL',
  'OTHER BIO HUMAN',
  'OTHER BIO OTHER',
  'OTHER CLINICAL TRIAL MATERIAL',
  'OTHER FILM',
  'OTHER FOODSTUFF',
  'OTHER MED TECH',
  'OTHER NON BIO',
  'OTHER PHARMA',
  'OTHER PLANT',
  'OTHER SAMPLES',
  'OTHER SUPPLIES',
  'OTHER TECH',
  'PAINT',
  'PASSPORTS',
  'PERSONAL EFFECT',
  'PHARMACEUTICAL - FINISHED PRODUCT',
  'PHARMACEUTICAL - RESEARCH/INVESTIGATIONAL',
  'PHOTOGRAPHS',
  'PLANT RNA',
  'PLANT SAMPLES',
  'PRINTED MATTER',
  'PROTEIN SAMPLES',
  'RADIOPHARMACEUTICAL UN2915 WHITE I',
  'RADIOPHARMACEUTICAL UN2915 YII',
  'RADIOPHARMACEUTICAL UN2915 YIII',
  'RAW MATERIALS/INTERMEDIATES',
  'REAGENT',
  'RECOMBINANT ADENOVIRUS UN3373',
  'RETURN DRUG',
  'RETURNED MATERIAL',
  'SALINE SOLUTION',
  'SAMPLES, ANIMAL',
  'SAMPLES, ANIMAL UN3373',
  'SAMPLES, HUMAN',
  'SAMPLES, HUMAN UN2814',
  'SAMPLES, HUMAN UN3373',
  'SEMICONDUCTOR',
  'SEMICONDUCTOR MASK',
  'SOIL SAMPLES',
  'SPARE PART',
  'TELECOM EQUIPMENT',
  'TEMP MONITORS',
  'VACCINES - FINISHED PRODUCT',
  'VACCINES - RESEARCH/INVESTIGATIONAL',
  'VEG EXTRACTS',
  'VEG PRODUCT',
  'VIRUSES (NON HUMAN/ANIMAL MEDIUM)',
  'WATER SAMPLES',
  'X-RAYS',
] as const satisfies readonly string[];

export const worldCourierItemNameSelectOptions: WcSelectOption[] =
  WORLD_COURIER_ITEM_NAME_LABELS.map((label) => ({
    value: label,
    label,
  }));
